import Icon, { ICON_BET_BUILDER, ICON_SUPER_SUB } from '~/components/icon';
import SportsbookTextKeys, { SportsbookTranslations } from '../../../sportsbook-text-keys';
import styled from 'styled-components';
import SportsbookTooltip from '../../sportsbook-tooltip';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	svg {
		color: var(--main-text-supportive);
	}
`;

type Props = {
	className?: string;
	hasBetBuilderForEvent: boolean;
	hasSuperSub?: boolean;
	translations: SportsbookTranslations;
};

const GameCardIcons: React.FC<Props> = ({ className, hasBetBuilderForEvent, hasSuperSub, translations }) => {
	if (!hasBetBuilderForEvent && !hasSuperSub) {
		return null;
	}

	return (
		<Wrapper className={className}>
			{hasBetBuilderForEvent && (
				<SportsbookTooltip label={translations[SportsbookTextKeys.BET_BUILDER_TOOLTIP_LABEL]}>
					<Icon type={ICON_BET_BUILDER} />
				</SportsbookTooltip>
			)}
			{hasSuperSub && (
				<SportsbookTooltip label={translations[SportsbookTextKeys.SUPER_SUB_TOOLTIP_LABEL]}>
					<Icon type={ICON_SUPER_SUB} />
				</SportsbookTooltip>
			)}
		</Wrapper>
	);
};

export default GameCardIcons;
